export const frontEndSettingsKey = 'quitmormon-front-end-settings';
export const ROOT_URL = process.env.VUE_APP_BASE_URL;
export const API_VER = 'v1';
export const SENTRY_DSN = '';
